
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs/[programSlug]/cohorts/[cohortSlug]",
      function () {
        return require("private-next-pages/programs/[programSlug]/cohorts/[cohortSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programs/[programSlug]/cohorts/[cohortSlug]"])
      });
    }
  